export default __webpack_public_path__ + "static/media/Macro2_rock_grout_imperiale.abc6c8f8.png";